import { useEffect } from "react"
import { parseGameReferrerFromUrl } from "@/utils/gameReferralLink"
import { setStoredGameReferrerCode } from "@/services/gameReferralStorage"

function storeReferrerFromLocation(): void {
  const code = parseGameReferrerFromUrl(window.location.href)
  if (code) setStoredGameReferrerCode(code)
}

export function useGameReferrerDeepLink(): void {
  useEffect(() => {
    storeReferrerFromLocation()
  }, [])
}
